module.exports = __webpack_public_path__ + "static/media/filled_bar_prewash10.bda66e07.svg";